module.exports = __webpack_public_path__ + "G.svg?93f0ffd310b8a2f904f563a52bf33598";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/G.svg
// module id = 59
// module chunks = 0